import { createDecorator } from '../../instantiation/common/instantiation.js';

const IDialogService = createDecorator('dialogService');

export { IDialogService };
